import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"

import styles from "./PaymentComplete.module.css"

import apiService from "@/provider/rest"
import CancelFeeLotteryCompleteSection from "@/public/components/features/payment/CancelFeeLottery/CancelFeeLotteryCompleteSection"
import {
	CancelFeeLottery,
	toCancelFeeLottery,
} from "@/public/components/features/payment/CancelFeeLottery/cancelFeeLottery"
import CompleteIcon from "@/public/components/ui/CompleteIcon/CompleteIcon"

type ConfirmPaymentResponse = {
	amount: number
	check_coupon_text?: string
	coupon_id?: string
	coupon_issued_text?: string
	// 支払い期限内のお支払いで抽選の応募が成立した時だけ返る
	lottery?: {
		multiplier: number
		prize_price: number
		wheel_multipliers: number[]
	} | null
	// 抽選セクションの抽選番号に使う
	cancel_id?: string
}

function PaymentComplete() {
	const navigate = useNavigate()
	const [amount, setAmount] = useState<number | undefined>(undefined)
	const [couponId, setCouponId] = useState<string | undefined>(undefined)
	const [couponIssuedText, setCouponIssuedText] = useState<string | undefined>(
		undefined
	)
	const [checkCouponText, setCheckCouponText] = useState<string | undefined>(
		undefined
	)
	const [cancelFeeLottery, setCancelFeeLottery] =
		useState<CancelFeeLottery | null>(null)
	const [cancelId, setCancelId] = useState("")
	const paymentID = useParams().payment_id
	useEffect(() => {
		const confirmPayment = async () => {
			try {
				const res = await apiService.post<ConfirmPaymentResponse>(
					"/public/payment/confirm",
					{
						payment_id: paymentID,
					}
				)
				console.log("resj")
				setAmount(res.amount)
				setCouponId(res.coupon_id)
				setCouponIssuedText(res.coupon_issued_text)
				setCheckCouponText(res.check_coupon_text)
				setCancelFeeLottery(toCancelFeeLottery(res.lottery))
				setCancelId(res.cancel_id ?? "")
			} catch (error) {
				console.log("error", error)
				alert("支払いは完了していません。")
				navigate("/payment/" + paymentID)
			}
		}
		void confirmPayment()
	}, [navigate, paymentID])
	if (!amount) {
		return <div>読み込み中...</div>
	}

	const coupon = couponId && couponIssuedText && checkCouponText && (
		<>
			<h3 className={styles.coupon_text}>{couponIssuedText}</h3>
			<p>使用期限がありますのでご注意ください</p>
			<button
				className={`common-button ${styles.payment_button}`}
				onClick={() => {
					navigate(`/coupon/${couponId}`)
				}}
			>
				{checkCouponText}
			</button>
		</>
	)

	// キャンセル料お支払いルーレットの応募が成立した時は、従来の完了表示の下に抽選セクションを足す.
	// 従来の画面は中央寄せの 1 画面固定 (main_content) で、セクションを足すと上が見切れるため、
	// こちらは上から並べる縦長のレイアウトにする (表記・アイコンは従来のまま).
	if (cancelFeeLottery !== null && cancelId !== "") {
		return (
			<div className={styles.lottery_content}>
				<CompleteIcon />
				<h2>お支払いが完了しました</h2>
				<p>￥{amount}の決済が正常に行われました</p>
				<div className={styles.lottery_section}>
					<CancelFeeLotteryCompleteSection
						lottery={cancelFeeLottery}
						cancelId={cancelId}
					/>
				</div>
				{coupon}
			</div>
		)
	}

	return (
		<div className={styles.main_content}>
			<CompleteIcon />
			<h2>お支払いが完了しました</h2>
			<p>￥{amount}の決済が正常に行われました</p>
			{coupon}
		</div>
	)
}

export default PaymentComplete
